/** Ordem dos produtos no Figma: Compartilhado, Exclusivo, Reunião, Eventos, Privativo. */
export const PRODUCT_DISPLAY_ORDER = [1, 3, 4, 5, 6];

export const compareProductOrder = (a: number, b: number) => {
  const ia = PRODUCT_DISPLAY_ORDER.indexOf(a);
  const ib = PRODUCT_DISPLAY_ORDER.indexOf(b);
  const unknown = PRODUCT_DISPLAY_ORDER.length;
  return (ia === -1 ? unknown : ia) - (ib === -1 ? unknown : ib);
};
